import "./whyustitle.styles.scss";

const WhyUsTitle = () => {
  return (
    <div className="title-wrapper">Why our service is the best choice?</div>
  );
};

export default WhyUsTitle;
